import React, {FC} from "react"

import {FormattedMessage, useIntl} from "@irati/utils/lang"
import {H1} from "@irati/ui/src/Typography"

import Tabs from "@irati/ui/src/Tabs"
import history, {historyContext} from "@irati/utils/history"
import {RouteComponentProps} from "react-router-dom"
import {WithAuth} from "@irati/auth/helpers/auth/withAuth"
import AccountRecognition from "./Recognition"
import AccountTrophies from "./Trophies"
import ScheduledRecognitions from "./Scheduled"
import ScheduledGroupCelebrations from "./ScheduledGroupCelebrations"
import AccountVotes from "./Recognition/AccountVotes"
import ClosedPolls from "./ClosedPolls"
import {isGlobalAdmin} from "@irati/identity/helpers/user/role"
import authentication from "@irati/auth"

const MY_RECOGNITION = "my-recognition"
const MY_VOTES = "my-votes"
const MY_TROPHIES = "my-trophies"
const MY_SCHEDULED = "my-scheduled"
const MY_CLOSED_POLLS = "my-closed-polls"
export const MY_GROUP_CELEBRATIONS = "my-group-celebrations"

interface Props extends WithAuth, RouteComponentProps<{recognitionType: string}> {}

const Account: FC<Props> = ({match}, context) => {
  const {formatMessage} = useIntl()
  const isAdmin = isGlobalAdmin(authentication.business(), authentication.user())
  const tabs = [
    {
      title: formatMessage({id: "recognition.account.recognition.tabs.recognition"}),
      key: MY_RECOGNITION,
      component: <AccountRecognition match={match} />
    },
    {
      title: formatMessage({id: "recognition.account.recognition.tabs.votes"}),
      key: MY_VOTES,
      component: <AccountVotes match={match} />
    },
    {
      title: formatMessage({id: "recognition.account.recognition.tabs.trophies"}),
      key: MY_TROPHIES,
      component: <AccountTrophies />
    },
    {
      title: formatMessage({id: "recognition.account.recognition.tabs.scheduled"}),
      key: MY_SCHEDULED,
      component: <ScheduledRecognitions />
    },
    {
      title: formatMessage({id: "recognition.account.recognition.tabs.groupCelebrations"}),
      key: MY_GROUP_CELEBRATIONS,
      component: <ScheduledGroupCelebrations match={match} />
    }
  ]

  if (isAdmin) {
    tabs.push({
      title: formatMessage({id: "recognition.account.recognition.tabs.closedPolls"}),
      key: MY_CLOSED_POLLS,
      component: <ClosedPolls match={match} />
    })
  }

  const getActiveKey = () => {
    const rType = match.params.recognitionType

    switch (rType) {
      case MY_TROPHIES:
        return MY_TROPHIES
      case MY_VOTES:
        return MY_VOTES
      case MY_RECOGNITION:
        return MY_RECOGNITION
      case MY_SCHEDULED:
        return MY_SCHEDULED
      case MY_GROUP_CELEBRATIONS:
        return MY_GROUP_CELEBRATIONS
      case MY_CLOSED_POLLS:
        return MY_CLOSED_POLLS
      default:
        return MY_RECOGNITION
    }
  }

  return (
    <>
      <H1 marginTop={5} marginBottom={5}>
        <FormattedMessage id="recognition.account.recognition.tabs.title" />
      </H1>
      <Tabs
        onSelect={(value) => {
          history.push(`/account/${value}`, context)
        }}
        activeKey={getActiveKey()}
        id="myRecognition"
        tabs={tabs}
      />
    </>
  )
}

Account.contextTypes = historyContext

export default Account
